import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarDivisaoEstoque(axios, parametros) {        
    parametros.operacao = 'buscarDivisaoEstoque';

    let retorno = {};

    await axios.santriGET('/rest/estoque', parametros, 15, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },
}


// WEBPACK FOOTER //
// ./src/components/Rest/REstoque/REstoqueBuscarDivisaoEstoque.js